const cookies = {
  cookieNode: null,
  cookieBtnNode: null,
  cookieName: 'dcookie',

  init() {
    this.cookieNode = document.querySelector('.js-cookies');

    if(this.cookieNode) {
      this.cookieBtnNode = this.cookieNode.querySelector('button');

      if(this.cookieBtnNode) {
        this.cookieBtnNode.addEventListener('click', () => this.handleClickBtn(), false);
      }

      this.checkCookie();
    }
  },

  handleClickBtn() {
    this.setCookie(this.cookieName);
    this.checkCookie();
  },

  checkCookie() {
    this.cookieNode.classList[this.getCookie(this.cookieName) ? 'add' : 'remove']('hidden');
  },

  setCookie(name, value = true, days = 7) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

    const expires = `expires=${date.toUTCString()}`;

    document.cookie = `${name}=${value || ''}; ${expires}; path=/`;
  },

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    return parts.length === 2 ? parts.pop().split(';').shift() : false;
  },
};

cookies.init();



// WEBPACK FOOTER //
// ./scripts/autoload/cookies.js